import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { isAdminUser } from "../utils/roleUtils";
import { decorateUiItems, findUiItemById } from "../utils/uiConfig";
import { getUiIcon } from "../utils/uiIcons";
import "./ReportsAnalyticsHome.css";

function ReportsAnalyticsHome() {
  const navigate = useNavigate();
  const { user, uiConfig } = useContext(AuthContext);
  const isAdmin = isAdminUser(user);

  const tools = useMemo(() => {
    const group = findUiItemById(uiConfig?.sidebarItems || [], "reports-analytics");
    return decorateUiItems(group?.children || [], { isAdmin })
      .filter((item) => item.id !== "analytics-home")
      .map((item) => ({ ...item, Icon: getUiIcon(item.icon) }));
  }, [isAdmin, uiConfig]);

  return (
    <div className="analytics-home-wrapper">
      <div className="analytics-home-header">
        <h2 className="analytics-home-title">Reports/Analytics</h2>
      </div>

      <div className="analytics-home-grid">
        {tools.map((tool) => {
          const Icon = tool.Icon;
          return (
            <button
              key={tool.id}
              type="button"
              className="analytics-home-card"
              onClick={() => navigate(tool.route)}
              style={{ "--accent-color": tool.accentColor || "#8b8c38" }}
            >
              <span className="analytics-home-icon">
                <Icon />
              </span>
              <span className="analytics-home-card-body">
                <span className="analytics-home-card-title">{tool.label}</span>
                <span className="analytics-home-card-desc">{tool.description}</span>
              </span>
              <span className="analytics-home-arrow">-&gt;</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ReportsAnalyticsHome;
